import { combineReducers } from 'redux';
import AuthReducer from './Auth';
import AppliedJobsReducer from './AppliedJobs';
import LookUpDataReducer from './LookUpData';
import JobsUrlReducer from './JobsUrl';

const allReducers = combineReducers({
  Auth: AuthReducer,
  AppliedJobs: AppliedJobsReducer,
  LookUpData: LookUpDataReducer,
  JobsUrl: JobsUrlReducer
})

export default allReducers;
